import { transformDateToLocalDateString } from "helpers";
import { formatKm } from "services/api/fleet/tires/helpers";
import { FleetTireSetUsage } from "services/api/fleet/tires/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import Badge from "ui/components/Badge/Badge";

export const TIRE_SET_USAGE_COLUMNS = (): Column[] => [
    {
        title: "Vozilo",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) => (
            <span className="text-sm">
                {row.vehicleName ?? "-"}
                {row.registrationPlate ? ` [${row.registrationPlate}]` : ""}
            </span>
        ),
    },
    {
        title: "Datum montaže",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) => (
            <span className="text-sm">{transformDateToLocalDateString(row.mountDate) ?? "-"}</span>
        ),
    },
    {
        title: "KM montaže",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) => <span className="text-sm">{formatKm(row.mountKm)}</span>,
    },
    {
        title: "Datum skidanja",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) =>
            row.isOpen ? (
                <Badge text="Na vozilu" variant="info" height="small" />
            ) : (
                <span className="text-sm">{transformDateToLocalDateString(row.demountDate) ?? "-"}</span>
            ),
    },
    {
        title: "KM skidanja",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) => <span className="text-sm">{formatKm(row.demountKm)}</span>,
    },
    {
        title: "Prijeđeno",
        field: "",
        type: ColumnTypes.custom,
        render: (row: FleetTireSetUsage) => (
            <span className="text-sm font-semibold">{formatKm(row.distanceKm)}</span>
        ),
    },
];
